
import { Component, Vue, Prop } from "vue-property-decorator"

@Component({})
export default class ViewFolderItem extends Vue {
	@Prop({ type: String, default: null })
	activeItemId!: string | null;

	@Prop({ type: String, default: "" })
	itemId!: string;

	@Prop({ type: String, default: "" })
	title!: string;

	@Prop({ type: Number, default: null })
	itemCount!: number | null;

	@Prop({ type: String, default: "v2-cases-overview" })
	toPath!: string;

	@Prop({ type: String, default: "viewId" })
	toParamName!: string
}
